import { Button } from './Button'
import { Dialog } from './Dialog'

export type ConfirmDestructiveActionProps = {
  open: boolean
  title: string
  body?: string
  confirmLabel?: string
  onConfirm: () => void
  onCancel: () => void
}

/**
 * Confirmation dialog for irreversible actions. The destructive button is
 * visually and spatially separated from the neutral cancel (spec §6.4).
 */
export function ConfirmDestructiveAction({
  open,
  title,
  body,
  confirmLabel = 'Verwijderen',
  onConfirm,
  onCancel,
}: ConfirmDestructiveActionProps) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      title={title}
      footer={
        <>
          <Button variant="ghost" onClick={onCancel}>
            Annuleren
          </Button>
          <Button variant="danger" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      {body && <p className="ui-confirm-destructive__body">{body}</p>}
    </Dialog>
  )
}
